import { Box } from '@mui/material';
import { TableTitleBox } from '../../common/components';
import CollectingEntitiesFilters from './components/CollectingEntitiesFilters';
import CollectionsSummaryModal from './components/modals/CollectionsSummaryModal';
import CollectingEntitiesDetailModal from './components/modals/CollectingEntitiesDetailModal';
import IntermediateEntitiesCollectionModal from './components/modals/IntermediateEntitiesCollectionModal';
import { useCollectingEntitiesStatistics } from './hooks/useCollectingEntitiesStatistics';
import {
  COLLECTING_ENTITIES_REPORT_OPTIONS,
  COLLECTING_ENTITIES_REPORT_TYPES,
} from './constants/collectingEntitiesConstants';

const CollectingEntitiesStatistics = () => {
  const {
    filters,
    loading,
    error,
    results,
    totals,
    summary,
    header,
    plans,
    groups,
    legalEntities,
    catalogsLoading,
    groupColumns,
    modalOpen,
    handleFilterChange,
    handleSubmit,
    handleCloseModal,
  } = useCollectingEntitiesStatistics();

  const renderModal = () => {
    if (!modalOpen) {
      return null;
    }

    if (filters.reportType === COLLECTING_ENTITIES_REPORT_TYPES.INTERMEDIATE) {
      return (
        <IntermediateEntitiesCollectionModal
          open={modalOpen}
          handleClose={handleCloseModal}
          header={header}
          results={results}
        />
      );
    }

    if (filters.reportType === COLLECTING_ENTITIES_REPORT_TYPES.DETAIL) {
      return (
        <CollectingEntitiesDetailModal
          open={modalOpen}
          handleClose={handleCloseModal}
          header={header}
          results={results}
          summary={summary}
        />
      );
    }

    return (
      <CollectionsSummaryModal
        open={modalOpen}
        handleClose={handleCloseModal}
        header={header}
        results={results}
        totals={totals}
        groupColumns={groupColumns}
      />
    );
  };

  return (
    <>
      <Box>
        <TableTitleBox title="Estadísticas | Entidades Recaudadoras" />
        <CollectingEntitiesFilters
          filters={filters}
          loading={loading}
          error={error}
          plans={plans}
          groups={groups}
          legalEntities={legalEntities}
          catalogsLoading={catalogsLoading}
          onFilterChange={handleFilterChange}
          onSubmit={handleSubmit}
          reportOptions={COLLECTING_ENTITIES_REPORT_OPTIONS}
        />
      </Box>

      {renderModal()}
    </>
  );
};

export default CollectingEntitiesStatistics;
